import queryString from 'query-string';

export interface IParams {
    [index: string]: string;
}

export const stringify = (params: IParams) => {
    return Object.keys(params)
        .map(key => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');
};

const decodeValue = (value?: any) => {
    if (value) {
        return decodeURIComponent(value);
    }
    return undefined;
};

export const parse = (locationSearch: string): { [key: string]: string } => {
    const params = queryString.parse(locationSearch);
    return Object.keys(params).reduce((reducer, key: string) => {
        return {
            ...reducer,
            [key]: decodeValue(params[key]),
        };
    }, {});
};

const hasQueryString = (url: string) => {
    return url.match(/\?./);
};

export const appendQueryString = (uri: string, params?: {}) => {
    if (params) {
        const queryParams = queryString.stringify(params);
        return `${uri}${hasQueryString(uri) ? '&' : '?'}${queryParams}`;
    }
    return uri;
};

export default {
    parse,
    stringify,
    appendQueryString,
};
